import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import WantListingShare from "@/components/WantListingShare";
import { getWantAdById } from "@/services/wantAdService";

const ResultsShare = ({ listing, label = "Share", ariaLabel, className = "results-share" }) => {
  const [target, setTarget] = useState(null);
  const [busy, setBusy] = useState(false);
  const pending = useRef(false);

  const open = async () => {
    if (pending.current || !listing?.id) return;
    pending.current = true;
    setBusy(true);
    try {
      const response = await getWantAdById(listing.id);
      if (response?.errorCode === 0 && response?.result) setTarget(response.result);
      else toast.error("Could not open sharing. Please try again.");
    } catch (error) {
      toast.error("Could not open sharing. Please try again.");
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };

  return (
    <>
      <button type="button" className={className} onClick={open} disabled={busy} aria-busy={busy || undefined} aria-label={ariaLabel}>
        {label}
      </button>
      {target ? (
        <WantListingShare adDetails={target} slug={listing.slug} audience="everyone" onHide={() => setTarget(null)} />
      ) : null}
    </>
  );
};

export default ResultsShare;
